import Model, { ID, IsoDateTime, JsonObject } from 'src/models/model'

export default class Version extends Model {
  static name = 'Version'

  oldValuePartialJsonSingleton = null
  newaluePartialJsonSingleton = null

  oldValueJsonSingleton = null
  newValueJsonSingleton = null

  oldValueObjectSingleton = null
  newValueObjectSingleton = null

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      itemType: {
        type: String,
        default: true
      },
      itemId: {
        type: ID,
        default: true
      },
      event: {
        type: String,
        default: true
      },
      // We don't need much user data, and this lets us easily redact user data
      // when currentUser does not have access to the version's user data.
      userData: {
        type: JsonObject,
        output: true,
        default: () => ({})
      },
      object: {
        type: JsonObject,
        default: true
      },
      objectChanges: {
        type: JsonObject,
        default: true
      },
      createdAt: {
        type: IsoDateTime,
        default: true
      }
    }

    this.queries = {
      versions: {
        arguments: {
          itemType: {
            type: String,
            required: true
          },
          itemId: {
            type: ID,
            required: true
          }
        },
        results: {
          versions: [Version]
        }
      }
    }
  }

  get oldValuePartialJson () {
    if (this.oldValuePartialJsonSingleton || this.oldValuePartialJsonSingleton === '') return this.oldValuePartialJsonSingleton

    this.oldValuePartialJsonSingleton = !this.object.object ? '' : `{ <span class="text-negative">${this.changedJson(this.objectChanges, true).join(',')}</span>, ... }`

    return this.oldValuePartialJsonSingleton
  }

  get newValuePartialJson () {
    if (this.newValuePartialJsonSingleton || this.newValuePartialJsonSingleton === '') return this.newValuePartialJsonSingleton

    const changes = this.changedJson(this.objectChanges, false)
    this.newValuePartialJsonSingleton = `{ <span class="text-positive">${changes.join(',')}</span>${!this.object.object ? '' : ', ...'} }`

    return this.newValuePartialJsonSingleton
  }

  get oldValue () {
    return this.object
  }

  get newValue () {
    if (this.newValueObjectSingleton) return this.newValueObjectSingleton

    const oldValue = JSON.stringify(this.oldValue, null, 2)
    const newValue = JSON.parse(_.clone(oldValue)) || {}

    _.each(this.objectChanges, (values, key) => {
      newValue[key] = values[1]
    })

    this.newValueObjectSingleton = newValue
    return this.newValueObjectSingleton
  }

  changedJson (changeList, original = false) {
    const changeIndex = original ? 0 : 1
    return _.map(changeList, (changes, key) =>
      (typeof changes[changeIndex] === 'string' || changes[changeIndex] instanceof String)
        ? `"${key}": "${changes[changeIndex]}"`
        : `"${key}": ${changes[changeIndex]}`
    )
  }

  highlightJson (json, highlights, color) {
    json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    return json.replace(new RegExp(`(${highlights.join('|')})`, 'g'), match => {
      return `<span class="text-${color}">${match}</span>`
    })
  }
}
